import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InvoiceApiService from '../../ApiServices/InvoiceApiService/InvoiceApiService';
import WebsiteApiService from '../../ApiServices/WebsiteApiService/WebsiteApiService';
import AppApiService from '../../ApiServices/WebsiteApiService/AppApiService';
import { useAuth } from "../Auth/AuthContext";

// Modal custom styles
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
        backgroundColor: '#f9f9f9',
        width: '500px',
    },
};

const AddInvoiceForm = () => {
    const [loading, setLoading] = useState(false);
    const [amount, setAmount] = useState('');
    const [dropdownOption, setDropdownOption] = useState('Website');
    const [urlOptions, setUrlOptions] = useState([]);
    const [selectedUrl, setSelectedUrl] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const Auth = useAuth();
    const user = Auth.authState.user;


    // Fetch URLs based on dropdown selection (Website or App)
    const fetchUrls = async () => {
        try {
            let response;
            if (dropdownOption === 'Website') {
                response = await WebsiteApiService.GetAllWebByUserId(user.id);
            } else {
                response = await AppApiService.GetAllAppByUserId(user.id);
            }

            const options = Array.isArray(response.data)
                ? response.data
                : [response.data];

            const formattedOptions = options.map(item => ({
                id: dropdownOption === 'Website' ? item.WebsiteId || item.websiteId : item.Id || item.id,
                name: item.Name || item.name,
                url: item.Url || item.url,
            }));

            setUrlOptions(formattedOptions);
        } catch (error) {
            console.error('Error fetching URLs:', error);
        }
    };

    useEffect(() => {
        fetchUrls();
    }, [dropdownOption]);

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!amount || !selectedUrl) {
            toast.error('Please fill in all fields.');
            return;
        }
debugger
        const invoiceData = {
            UserId: user.id,
            // PreviousMonth: secondPreviousMonth,
            PreviousMonth: selectedMonth.split('-')[1], // Extract the month (e.g., "October")
            Year: selectedMonth.split('-')[0], // Extract the year (e.g., "2024")
            IsPaid: false,
            Revenue: parseFloat(amount),
            // type: dropdownOption,
            WebsiteAppId: parseInt(selectedUrl), // WebsiteId or AppId
            IsApp: dropdownOption.toLowerCase() === 'app', // IsAppId
        };

        setLoading(true);

        try {
            await InvoiceApiService.Add(invoiceData);
            toast.success('Invoice added successfully!');
            setAmount('');
            setSelectedUrl('');
        } catch (error) {
            console.error('Error adding invoice:', error);
            toast.error('Failed to add invoice.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="p-6">
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium mb-1">Invoice Month</label>
                        <input
                            type="month"
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            className="w-full border rounded px-3 py-2"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Amount</label>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter amount"
                            className="w-full border rounded px-3 py-2"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Type</label>
                        <select
                            value={dropdownOption}
                            onChange={(e) => setDropdownOption(e.target.value)}
                            className="w-full border rounded px-3 py-2"
                        >
                            <option value="Website">Website</option>
                            <option value="App">App</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">
                            {dropdownOption} URL
                        </label>
                        <select
                            value={selectedUrl}
                            onChange={(e) => setSelectedUrl(e.target.value)}
                            className="w-full border rounded px-3 py-2"
                            required
                        >
                            <option value="">Select {dropdownOption} URL</option>
                            {urlOptions.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.name} - {option.url}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 rounded font-medium"
                        disabled={loading}
                    >
                        {loading ? 'Submitting...' : 'Add Invoice'}
                    </button>
                </form>
            </div>
        </>
    );
};

export default AddInvoiceForm;
